module.exports = __webpack_public_path__ + "static/media/li.ca65e1ea.svg";